/** MeetingProcessingStageTag — 处理阶段标签，卡片与详情头部共用。 */

import { Tag } from "antd";
import type { MeetingProcessingStage } from "../../types/meeting";
import {
  MEETING_PROCESSING_STAGE_COLORS,
  MEETING_PROCESSING_STAGE_LABELS,
} from "../../types/meeting";

interface MeetingProcessingStageTagProps {
  stage: MeetingProcessingStage;
  "data-testid"?: string;
}

export default function MeetingProcessingStageTag({
  stage,
  "data-testid": testId,
}: MeetingProcessingStageTagProps) {
  return (
    <Tag color={MEETING_PROCESSING_STAGE_COLORS[stage]} data-testid={testId ?? `meeting-processing-stage-${stage}`}>
      {MEETING_PROCESSING_STAGE_LABELS[stage]}
    </Tag>
  );
}
